import React from 'react';
import Navbar from '../../components/Navbar/Navbar';

const News = () => {
    return (
        <div>
            <Navbar></Navbar>
            <h3>Hello from news!</h3>
        </div>
    );
};

export default News;